import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var text_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section2 ul li .text').each(function() { //遍历相同样式名的元素
    var text = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    text_max = text > text_max ? text : text_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section2 ul li .text').height(text_max); //给每一个元素设置相同的高度

function countUp(el){
    let target = parseFloat(el.data('num'));
    $({count:0}).animate(
        {count:target},
        {
            duration:2000,
            step:function(now){
                el.text(Math.floor(now));
            },
            complete:function(){
                el.text(target);
            }
        }
    );
}

let played = false;
$(window).on('scroll',function(){
    let top = $('.stats').offset().top;
    let winTop = $(window).scrollTop();
    let winH = $(window).height();
    if(!played && winTop + winH > top){
        played = true;
        $('.item').each(function(index){
            let _this = $(this);
            setTimeout(function(){
                _this.addClass('show');
                countUp(
                    _this.find('.num')
                );
            },index * 250);
        });
    }
}).trigger('scroll');


var packagingSwiper = new Swiper(".section5 .swiper", {
    speed:500,
    navigation: {
        nextEl: ".section5 .next",
        prevEl: ".section5 .prev",
    },
    pagination: {
        el: ".section5 .swiper-pagination",
        clickable: true,
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        spaceBetween: 32,
        slidesPerGroup: 4,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
      }
    } 
});


$(".section6 ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section6 .text .tab").eq(index).addClass("active").siblings().removeClass("active");
},function() {
    $(".section6 ul li").removeClass("active");
    $(".section6 .text .tab").removeClass("active");
})